import { Layout } from 'antd';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { AppConfigProvider } from 'src/components/AppConfigProvider';
import { FormWrapperForTaskWithAction } from 'src/components/FormForTaskWithAction/FormWrapperForTaskWithAction';
import { Header } from 'src/components/Header';
import { LicenseExpirationWarning } from 'src/components/LicenseExpirationWarning/LicenseExpirationWarning';
import { SplashScreen } from 'src/components/SplashScreen/SplashScreen';
import { RoutesLayout } from 'src/containers/RoutesLayout/RoutesLayout';
import { useUrlUiSettings } from 'src/hooks/useUrlUiSettings';
import { UrgentTaskView } from 'src/pages/UrgentTaskView/UrgentTaskView';
import { AppStore } from 'src/stores/AppStore/AppStore';
import { AuthStore } from 'src/stores/AuthStore/AuthStore';
import { SettingsLicenseStore } from 'src/stores/SettingsStores/SettingsLicenseStore/SettingsLicenseStore';
import { TaskStore } from 'src/stores/TaskStore/TaskStore';
import { CssVariables } from 'src/styles/CssVariables';
import styled from 'styled-components';

export const AppLayout = observer(() => {
    useUrlUiSettings();
    const { isLicenseExpiring } = SettingsLicenseStore;

    useEffect(() => {
        if (AuthStore.authenticated) {
            TaskStore.loadAssignedTaskList();
        }
    }, [AuthStore.authenticated]);

    if (
        !AuthStore.authenticated ||
        !AppStore.started ||
        !TaskStore.assignedTaskLoaded
    ) {
        return <SplashScreen />;
    }

    return (
        <AppConfigProvider>
            <Layout>
                <FormWrapperForTaskWithAction />
                {TaskStore.isHasUrgentTask ? (
                    <UrgentTaskView />
                ) : (
                    <>
                        <LicenseExpirationWarning />
                        <Header />
                        <StyledContent $hasWarning={isLicenseExpiring}>
                            <RoutesLayout />
                        </StyledContent>
                    </>
                )}
            </Layout>
        </AppConfigProvider>
    );
});

const StyledContent = styled(Layout.Content)<{ $hasWarning?: boolean }>`
    background-color: var(--background);
    margin-top: ${(props) =>
        props.$hasWarning
            ? `calc(${CssVariables.headerHeight} + ${CssVariables.licenseWarningHeight})`
            : CssVariables.headerHeight};
    height: ${(props) =>
        props.$hasWarning
            ? `calc(100vh - ${CssVariables.headerHeight} - ${CssVariables.licenseWarningHeight})`
            : `calc(100vh - ${CssVariables.headerHeight})`};
`;
